import { render, staticRenderFns } from "./fieldList.vue?vue&type=template&id=38562b44&scoped=true&"
import script from "./fieldList.vue?vue&type=script&lang=js&"
export * from "./fieldList.vue?vue&type=script&lang=js&"
import style0 from "./fieldList.vue?vue&type=style&index=0&id=38562b44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38562b44",
  null
  
)

export default component.exports